module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAAUdEVYdENyZWF0aW9uIFRpbWUAOC8zLzE1QclJHgAAAOtJREFUWIXt11FKAzEQxvFfbA8hVG9S6UkEwXdP4iUEz9AL7ILn8KGsHmKJD201Dau7gtv4kO8pwzDMn8k3kIQYo5K6KNr9PwAsk/MjNlicoW+LB04nsMH1GQBWWB+DdAILvOMe3YwA2zRYZskeXQhhN1f3GGOfxsVNWBwgv4JPxRjXuMUl3vAcQmgGcmM6qZ0MgBvc2ZuzxyuagdyY8trJAC2efE2g+SY3prx2GsBhZIOFP+V+q+ImLA5Qt6BuQXETFgeoW1C3oLgJiwPkV7DCNn84/rGuJK/udAItdvaunVMdXo5BqJ/T0gAfQvVwj0D6lfcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/FooterMobile/toolbar_icon_wall.png
// module id = 1564
// module chunks = 1